<app-header></app-header>

<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h2 class="login-title">Accédez à votre espace client</h2>
      <p class="login-subtitle">Connectez-vous pour accéder à vos documents et services</p>
    </div>
    
    <form class="login-form" (ngSubmit)="onSubmit()" #loginForm="ngForm">
      <!-- Messages d'erreur et de succès -->
      <div class="alert alert-error" *ngIf="errorMessage">
        <i class="bi bi-exclamation-triangle"></i>
        {{ errorMessage }}
      </div>
      
      <div class="alert alert-success" *ngIf="successMessage">
        <i class="bi bi-check-circle"></i>
        {{ successMessage }}
      </div>

      <div class="form-group">
        <label for="email" class="form-label">
          <i class="bi bi-envelope"></i>
          Adresse e-mail
        </label>
        <input 
          type="email" 
          id="email" 
          name="email"
          class="form-control"
          [(ngModel)]="loginData.email"
          #email="ngModel"
          required
          email
          placeholder="votre@email.com"
        >
        <div class="error-message" *ngIf="email.invalid && email.touched">
          <span *ngIf="email.errors?.['required']">L'adresse e-mail est requise</span>
          <span *ngIf="email.errors?.['email']">Veuillez saisir une adresse e-mail valide</span>
        </div>
      </div>

      <div class="form-group">
        <label for="password" class="form-label">
          <i class="bi bi-lock"></i>
          Mot de passe
        </label>
        <div class="password-input-container">
          <input 
            [type]="showPassword ? 'text' : 'password'" 
            id="password" 
            name="password"
            class="form-control"
            [(ngModel)]="loginData.password"
            #password="ngModel"
            required
            placeholder="Votre mot de passe"
          >
          <button 
            type="button" 
            class="password-toggle"
            (click)="togglePasswordVisibility()"
            [attr.aria-label]="showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'"
          >
            <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
          </button>
        </div>
        <div class="error-message" *ngIf="password.invalid && password.touched">
          <span *ngIf="password.errors?.['required']">Le mot de passe est requis</span>
        </div>
      </div>

      <button 
        type="submit" 
        class="login-btn"
        [disabled]="loginForm.invalid || isLoading"
      >
        <span *ngIf="!isLoading">
          <i class="bi bi-box-arrow-in-right"></i>
          Accéder à mon espace
        </span>
        <span *ngIf="isLoading">
          <i class="bi bi-arrow-clockwise spin"></i>
          Connexion en cours...
        </span>
      </button>

    </form>
  </div>
</div>

<app-footer></app-footer>
